/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {batch} from 'react-redux';
import {cloneDeep} from 'lodash';
import {findCurrentAccountMatch} from '@ion/core/src/entities/Accounts';
import {isIgnitionOff} from '@ion/core/src/entities/Asset';
import {getCVSAssets} from '@ion/core/src/services/ArcGIS';
import {entityId} from '@ion/core/src/services/ConnectUtils';
import Device from '@ion/core/src/services/Device';
import {EventCode, getDefaultEventList} from '@ion/core/src/services/EventCodes';
import {registerToken} from '@ion/core/src/services/Reports';
import Sisense, {DashboardId} from '@ion/core/src/services/Sisense';
import {
  BaseAsset,
  GenericObject,
  HistoryEventByAsset,
  HVSRecord
} from '@ion/core/src/types/entities';
import {
  deepCopy
} from '@ion/core/src/utils/ObjectUtil';
import {
  trimAll
} from '@ion/core/src/utils/StringUtil';
import {FilterModel} from '@ion/dls/src/grid/IonGridUtils';
import {dateFilterMap} from '@ion/dls/src/helpers/dateFilterMap';
import {BoundaryMode, CreateGeoFenceTypeEnum, Filters} from '@ion/dls/src/types/types';
import {getItemValue} from '../../routes/tracking/trackingUtils';
import {hasSisenseAccess} from '../../security/Features';
import {ReportsMode} from '../../types/redux';
import {getAllAccountIds} from '../helpers';
import {ReportsFilter} from '../reducers/reports';
import {APPLY_DATE, exitFindNearby} from './tracking';

export const INITIALIZE_REPORTS             = 'INITIALIZE_REPORTS';
export const SET_HISTORY_ASSETS             = 'SET_HISTORY_ASSETS';
export const SET_HISTORY_GROUPS             = 'SET_HISTORY_GROUPS';
export const SET_HOVERED_HISTORY_EVENT      = 'SET_HOVERED_HISTORY_EVENT';
export const GET_ASSETS_HISTORY_REQUEST     = 'GET_ASSET_HISTORY_REQUEST';
export const REMOVE_ASSETS_HISTORY_REQUEST  = 'REMOVE_ASSETS_HISTORY_REQUEST';
export const DATE_FILTER_REQUEST            = 'DATE_FILTER_REQUEST';
export const UPDATE_DATE_VALUE              = 'UPDATE_DATE_VALUE';
export const GET_ASSETS_HISTORY_RESPONSE    = 'GET_ASSET_HISTORY_RESPONSE';
export const SET_ASSETS_HISTORY_LOADING     = 'SET_ASSETS_HISTORY_LOADING';
export const GET_ASSETS_HISTORY_ERROR       = 'GET_ASSET_HISTORY_ERROR';
export const RESET_REPORTS                  = 'RESET_REPORTS';
export const GET_OPERATORS_FILTERS_REQUEST  = 'GET_OPERATORS_FILTERS_REQUEST';
export const GET_OPERATORS_FILTERS_RESPONSE = 'GET_OPERATORS_FILTERS_RESPONSE';
export const GET_OPERATORS_FILTERS_ERROR    = 'GET_OPERATORS_FILTERS_ERROR';
export const GET_EVENTS_FILTERS_REQUEST     = 'GET_EVENTS_FILTERS_REQUEST';
export const GET_EVENTS_FILTERS_RESPONSE    = 'GET_EVENTS_FILTERS_RESPONSE';
export const GET_EVENTS_FILTERS_ERROR       = 'GET_EVENTS_FILTERS_ERROR';
export const GET_LOCATIONS_FILTERS_REQUEST  = 'GET_LOCATIONS_FILTERS_REQUEST';
export const GET_LOCATIONS_FILTERS_RESPONSE = 'GET_LOCATIONS_FILTERS_RESPONSE';
export const GET_LOCATIONS_FILTERS_ERROR    = 'GET_LOCATIONS_FILTERS_ERROR';
export const GET_DATE_FILTERS_REQUEST       = 'GET_DATE_FILTERS_REQUEST';
export const GET_DATE_FILTERS_RESPONSE      = 'GET_DATE_FILTERS_RESPONSE';
export const GET_DATE_FILTERS_ERROR         = 'GET_DATE_FILTERS_ERROR';
export const SET_OPERATORS_FILTERS_REQUEST  = 'SET_OPERATORS_FILTERS_REQUEST';
export const SET_EVENTS_FILTERS_REQUEST     = 'SET_EVENTS_FILTERS_REQUEST';
export const SET_LOCATIONS_FILTERS_REQUEST  = 'SET_LOCATIONS_FILTERS_REQUEST';
export const SET_DATE_FILTERS_REQUEST       = 'SET_DATE_FILTERS_REQUEST';
export const ASSET_HISTORY_FILTER_REQUEST   = 'ASSET_HISTORY_FILTER_REQUEST';
export const APPLY_EVENTS_FILTER            = 'APPLY_EVENTS_FILTER';
export const APPLY_GROUPS_FILTER            = 'APPLY_GROUPS_FILTER';
export const APPLY_DEVICES_FILTER           = 'APPLY_DEVICES_FILTER';
export const APPLY_CATEGORIES_FILTER        = 'APPLY_CATEGORIES_FILTER';
export const APPLY_TYPES_FILTER             = 'APPLY_TYPES_FILTER';
export const APPLY_ASSETS_FILTER            = 'APPLY_ASSETS_FILTER';
export const ASSET_FILTER_LOADING           = 'ASSET_FILTER_LOADING';
export const GET_FILTER_REQUEST             = 'SET_ALL_FILTERS_LOADING_STATE';
export const TOGGLE_MOBILE_FILTERS          = 'TOGGLE_MOBILE_FILTERS';
export const CLEAR_FILTERS                  = 'CLEAR_FILTERS';
export const TOGGLE_GRID_GROUPS_EXPANDED    = 'TOGGLE_GRID_GROUPS_EXPANDED';
export const TOGGLE_GRID_ASSETS_EXPANDED    = 'TOGGLE_GRID_ASSETS_EXPANDED';
export const SET_HISTORY_DATE_RANGE         = 'SET_HISTORY_DATE_RANGE';
export const SET_BOUNDARY_PANEL_OPEN        = 'SET_BOUNDARY_PANEL_OPEN';
export const SET_SELECTED_BOUNDARY_TOOL     = 'SET_SELECTED_BOUNDARY_TOOL';

export const SET_IS_MOBILE_MAP_VIEW         = 'SET_IS_MOBILE_MAP_VIEW';

// AHR Settings
export const TOGGLE_SHOW_SUMMARY_CARDS        = 'TOGGLE_SHOW_SUMMARY_CARDS';
export const TOGGLE_SHOW_SUMMARY_CARD         = 'TOGGLE_SHOW_SUMMARY_CARD';
export const TOGGLE_DISTANCE_TRAVELLED_CARD   = 'TOGGLE_DISTANCE_TRAVELLED_CARD';
export const TOGGLE_IDLING_TIME_CARD          = 'TOGGLE_IDLING_TIME_CARD';
export const TOGGLE_DRIVING_TIME_CARD         = 'TOGGLE_DRIVING_TIME_CARD';
export const TOGGLE_HARSH_EVENTS_CARD         = 'TOGGLE_HARSH_EVENTS_CARD';
export const TOGGLE_TOTAL_ASSETS_CARD         = 'TOGGLE_TOTAL_ASSETS_CARD';
export const TOGGLE_SHOW_TRIP_VISIBLE         = 'TOGGLE_SHOW_TRIP_VISIBLE';
export const TOGGLE_SHOW_EVENTS_BETWEEN_TRIPS = 'TOGGLE_SHOW_EVENTS_BETWEEN_TRIPS';

// register token action ...
export const REGISTER_TOKEN_SUCCESS           = 'REGISTER_TOKEN_SUCCESS';

// grid column state
export const SET_GRID_COLUMNS              = 'SET_ASSET_HISTORY_GRID_COLUMNS';
export const UPDATE_GRID_COLUMNS           = 'UPDATE_ASSET_HISTORY_GRID_COLUMNS';
export const SET_SHIPPING_GRID_COLUMNS     = 'SET_SHIPPING_HISTORY_GRID_COLUMNS';
export const UPDATE_SHIPPING_GRID_COLUMNS  = 'UPDATE_SHIPPING_HISTORY_GRID_COLUMNS';

export const SET_HISTORY_MAP_PROPS         = 'SET_HISTORY_MAP_PROPS';

// DVR supported assets
export const SET_DVR_ASSETS = 'SET_DVR_ASSETS';

// Sisense repated actions
export const SET_SISENSE_DEFAULT_DASHBOARD = 'SET_SISENSE_DEFAULT_DASHBOARD';

// grid column state
export const SET_ASSETS_HISTORY_REPORT_ERROR  = 'SET_ASSETS_HISTORY_REPORT_ERROR';

// Set timeline date range
export const SET_TIMELINE_DATE_RANGE = 'SET_TIMELINE_DATE_RANGE';
// Toggle timeSlider
export const TOGGLE_TIMESLIDER = 'TOGGLE_TIMESLIDER';
// name of the reducer
export const NAME = 'reports';

export const SET_HISTORY_GRID_FILTER_MODEL = 'SET_HISTORY_GRID_FILTER_MODEL';

export interface LoadAssetHistoryParams {
  initialAsset?: BaseAsset[],
  date?: GenericObject,
  filters?: ReportsFilter,
  geometry?: number[],
  isTracking?: boolean
};

/**
 * @initialize
 */
export const initializeReports = () => {
  return ({type: INITIALIZE_REPORTS});
};

export const setHistoryMapProps = props => ({
  type : SET_HISTORY_MAP_PROPS, props
});

// invoked by IonGrid when the grid filter model changed...
export const setFilterModel = (filterModel: FilterModel) => ({
  type : SET_HISTORY_GRID_FILTER_MODEL, filterModel
});

// trigger to open and close the create boundary panel in map...
export const setBoundaryPanelOpen = (boundaryPanelOpen: boolean, mode?: BoundaryMode) => ({
  type : SET_BOUNDARY_PANEL_OPEN, boundaryPanelOpen, mode
});

// trigger to open and close the create boundary panel in map...
export const setBoundaryDrawingTool = (selectedBoundaryTool: CreateGeoFenceTypeEnum = null) => ({
  type : SET_SELECTED_BOUNDARY_TOOL, selectedBoundaryTool
});

export const setAssetHistoryFilters = () => {
  return dispatch => {
    batch(() => {
      dispatch(loadGroups());
      dispatch(loadEvents());
    });
  };
};

/**
 * @setHistoryAsset
 */
export const setHistoryAsset = (asset?: Device, isDeeplink = false) => {
  return dispatch => {
    dispatch(clearFilters());
    if (asset) {
      const assetDevice = getItemValue(asset);
      // Create a mask to map the grid filter the event for the asset is selected
      // from map
      const deeplinkinkAsset = {...assetDevice, isMapClick: isDeeplink};
      dispatch({type: SET_HOVERED_HISTORY_EVENT, asset: deeplinkinkAsset});
      dispatch({type: APPLY_ASSETS_FILTER, selected: [deeplinkinkAsset]});
    } else {
      dispatch({type: SET_ASSETS_HISTORY_LOADING, loading: false});
    }
  };
};

/**
 * @setHoveredEvent
 *
 * Invoked when an asset within the reports grid or map is hovered.
 */
export const setHoveredHistoryEvent = (event: HVSRecord | null) => ({
  type : SET_HOVERED_HISTORY_EVENT, event
});

const getFilteredEventHistory = (history: HVSRecord[], selectedEvents: EventCode[]) => {
  let filteredHistory: HVSRecord[];
  if (history?.length) {
    const historyCopy = cloneDeep(history);
    filteredHistory = historyCopy.reduce((acc, item) => {
      const matchedEvent = Boolean(selectedEvents.find(({eventCode}) => eventCode === item.eventCode));
      item.gridVisibility = matchedEvent;
      item.mapVisibility  = matchedEvent || isIgnitionOff(item);
      return [...acc, item];
    }, []);
  }
  return filteredHistory;
};

export const loadGroups = () => {
  return async(dispatch, getState) => {
    const {
      globalGroup : {
        globalGroupId,
        globalGroup,
        accountHierarchy
      },
      reports: {
        filters : {
          groups : {
            items
          }
        }
      }
    } = getState();
    const match = findCurrentAccountMatch(accountHierarchy, globalGroup);
    dispatch({type: SET_HISTORY_GROUPS, groups: match});
    return true;
  };
};

export const loadAssets = () => {
  return async(dispatch, getState) => {
    const {
      globalGroup: {
        globalGroupId
      }
    } = getState();

    batch(async() => {
      dispatch({type: ASSET_FILTER_LOADING});
      const groups = getAllAccountIds(getState, entityId(globalGroupId));
      const assets = await getCVSAssets({groups});
      dispatch({type: SET_HISTORY_ASSETS, assets});
    });
    return true;
  };
};

export const loadEvents = () => {
  return async(dispatch, getState) => {
    const defaultEvents = getDefaultEventList();
    dispatch({type: GET_EVENTS_FILTERS_RESPONSE, items: defaultEvents});
    return true;
  };
};

/**
 * isOngoingTrip determines if igOn or igOff comes first by looping through
 * the array of events.
 * if igOff comes first, start of the date requested is in the
 * middle of the tripGroup.
 *
 * ```typescript
 *
 * const onGoingTrip: boolean = isOngoingTrip(events);
 * ...
 *
 * ```
 */
export const isOngoingTrip = (events: HVSRecord[]) => {
  // loop through events and check if igOn or igOff comes first
  // if igOff comes first, start of the date requested is in the
  // middle of the ongoing trip.

  const igOnIndex = events.findIndex(({eventType}) => eventType === HistoryEventByAsset.IGON);
  const igOffIndex = events.findIndex(({eventType}) => eventType === HistoryEventByAsset.IGOFF);

  // verify if igOn and igOff are both found
  if (igOnIndex !== -1 && igOffIndex !== -1) {
    return igOnIndex > igOffIndex;
  }
  // case where no igOn/ igOff found
  return true;
};

export const applyAssetHistoryDateFilter = (
  date?: GenericObject
) => {
  return async(dispatch) => {
    dispatch({type: APPLY_DATE, date});
  };
};

export const applyAssetHistoryEventFilter = (
  selectedEvents?: EventCode[]
) => {
  return async(dispatch, getState) => {
    const {
      reports : {
        history : {
          history = []
        } = {}
      } = {}
    } = getState();
    const filteredHistory: HVSRecord[] = getFilteredEventHistory(history, selectedEvents);
    dispatch({type: APPLY_EVENTS_FILTER, filteredHistory, items: selectedEvents});
  };
};

interface applyFilterParams {
  filterType: Filters,
  selected: any[],
  filters: ReportsFilter,
  reportType: ReportsMode
}

export const applyFilter = ({
  filterType,
  selected,
  filters,
  reportType = ReportsMode.AssetHistory
}: applyFilterParams) => {
  return async(dispatch) => {
    switch (filterType) {
      case 'groups':
        dispatch({type: APPLY_GROUPS_FILTER, reportType, selected: filters?.groups?.selected});
        dispatch({type: APPLY_ASSETS_FILTER, reportType, selected: filters?.assets?.selected});
        dispatch({type: APPLY_DEVICES_FILTER, reportType, selected: filters?.devices?.selected});
        break;
      case 'events':
        dispatch({type: APPLY_EVENTS_FILTER, reportType, selected: filters?.events?.selected});
        break;
      case 'categories':
        dispatch({type: APPLY_CATEGORIES_FILTER, reportType, selected: filters?.categories?.selected});
        break;
      case 'types':
        dispatch({type: APPLY_TYPES_FILTER, reportType, selected: filters?.types?.selected});
        break;
      case 'assets':
        dispatch({type: APPLY_ASSETS_FILTER, reportType, selected: filters?.assets?.selected});
        break;
      case 'date':
        dispatch({type: DATE_FILTER_REQUEST, reportType, date: filters.date});
        break;
      default:
        break;
    }
  };
};

export const clearFilters = (reportType: ReportsMode = ReportsMode.AssetHistory): any => {
  return async(dispatch) => {
    dispatch(exitFindNearby() as any);
    dispatch({type: CLEAR_FILTERS, reportType});
  };
};

export const applyAssetHistoryFilter = (rows) => {
  return async(dispatch, getState) => {
    const {
      reports : {
        history : {
          history
        }
      }
    } = getState();
    const filteredHistory = deepCopy(history).map(item => {
      const hasItem = Boolean(item && rows.find(({OBJECTID}) => OBJECTID === item?.OBJECTID));
      return {
        ...item,
        gridVisibility : hasItem,
        mapVisibility  : hasItem
      };
    }, []);
    dispatch({type: GET_ASSETS_HISTORY_RESPONSE, allHistory: filteredHistory});
  };
};

/**
 * Provides an action which, when dispatched, will initialize and update the state of the
 *asset history operators filters.
 */
export const getOperatorsFilters = () => {
  return async(dispatch, getState) => {
    dispatch({type: GET_OPERATORS_FILTERS_REQUEST});
    try {
      const items = [];
      dispatch({type: GET_OPERATORS_FILTERS_RESPONSE, items});
    } catch (error) {
      dispatch({type: GET_OPERATORS_FILTERS_ERROR, error});
    }
  };
};

/**
 * Provides an action which, when dispatched, will initialise and update the state of the
 * asset's asset history events filters.
 */
export const getEventsFilters = () => {
  return async(dispatch, getState) => {
    dispatch({type: GET_EVENTS_FILTERS_REQUEST});
    try {
      const items = [];
      dispatch({type: GET_EVENTS_FILTERS_RESPONSE, items});
    } catch (error) {
      dispatch({type: GET_EVENTS_FILTERS_ERROR, error});
    }
  };
};

/**
 * Provides an action which, when dispatched, will initialize and update the state of the
 * asset history locations filters.
 */
export const getLocationsFilters = () => {
  return async(dispatch, getState) => {
    dispatch({type: GET_LOCATIONS_FILTERS_REQUEST});
    try {
      const items = [];
      dispatch({type: GET_LOCATIONS_FILTERS_RESPONSE, items});
    } catch (error) {
      dispatch({type: GET_LOCATIONS_FILTERS_ERROR, error});
    }
  };
};

/**
 * Provides an action which, when dispatched, will initialize and update the state of the
 * asset's asset history date filters.
 */
export const getDateFilters = () => {
  return async(dispatch, getState) => {
    dispatch({type: GET_DATE_FILTERS_REQUEST});
    try {
      const items = [];
      dispatch({type: GET_DATE_FILTERS_RESPONSE, items});
    } catch (error) {
      dispatch({type: GET_DATE_FILTERS_ERROR, error});
    }
  };
};

/**
 * Provides an action which, when dispatched, will update the state of the
 * asset's asset history operators filters.
 */
export const setOperatorsFilters = (value) => ({type: SET_OPERATORS_FILTERS_REQUEST, value});

/**
 * Provides an action which, when dispatched, will update the state of the
 * asset's asset history events filters.
 */
export const setEventsFilters = (value) => ({type: SET_EVENTS_FILTERS_REQUEST, value});

/**
 * Provides an action which, when dispatched, will update the state of the
 * asset's asset history locations filters.
 */
export const setLocationsFilters = (value) => ({type: SET_LOCATIONS_FILTERS_REQUEST, value});

/**
 * Provides an action which, when dispatched, will update the state of the
 * asset history date filters.
 */
export const setDateFilters = (value, processDate, processedDate) => {
  let requestParam;
  if (!processDate) {
    requestParam = processedDate;
  } else {
    const val = trimAll(value[0])?.toLowerCase();
    requestParam = dateFilterMap[val];
  }
  return ({type: SET_DATE_FILTERS_REQUEST, value});
};

/**
 * This function checks if the user has access to Sisense. If the user
 * has access to either, it registers the token and dispatches actions accordingly.
 * Initiates the process for retrieving report options from meta server.
 *
 *  ```typescript
 *
 *  import {retrieveReportOptions} from '../../store/actions/reports';
 *
 *  const dispatch = useDispatch();
 *  dispatch(retrieveReportOptions());
 *
 * ```
 */
export const retrieveReportOptions = () => {
  return async(dispatch: Function, getState: Function): Promise<any> => {
    const {
      reports: {
        isTokenRegistered
      }
    } = getState();
    const isSisensePermitted = hasSisenseAccess();
    Sisense.setPermitted(isSisensePermitted);

    // If the user has access to Sisense, register the token
    if (!isTokenRegistered && isSisensePermitted) {
      await registerToken();
      dispatch({type: REGISTER_TOKEN_SUCCESS});
    }
    // If the user has Sisense access, retrieve Sisense options
    if (isSisensePermitted) {
      Sisense.retrieveOptions();
    }
  };
};

/**
 * Action creator that handles expanding and collapsing asset history trip group rows.
 */
export const toggleAssetHistoryExpandedGroups = (id: string, isExpanded: boolean = false) => {
  return {type: TOGGLE_GRID_GROUPS_EXPANDED, id, isExpanded};
};

/**
 * Action creator that handles expanding and collapsing asset history trip Asset parent rows.
 */
export const toggleAssetHistoryExpandedAssets = (id: string, isExpanded: boolean = false) => {
  return {type: TOGGLE_GRID_ASSETS_EXPANDED, id, isExpanded};
};

/**
 * @setHistoryDateRange
 */
export const setHistoryDateRange = (start, end) => {
  return ({type: SET_HISTORY_DATE_RANGE, start, end});
};

/**
 * @setTimelineDateRange
 */
export const setTimelineDateRange = (start, end) => ({
  type : SET_TIMELINE_DATE_RANGE, start, end
});

/**
 * @getAssetHistoryRequest
 */
export const getAssetHistoryRequest = () => ({
  type : GET_ASSETS_HISTORY_REQUEST
});

/**
 * @removeAssetHistoryRequest
 */
export const removeAssetHistoryRequest = () => ({
  type : REMOVE_ASSETS_HISTORY_REQUEST
});

/**
 * @toggleTimeSlider
 */
export const toggleTimeSlider = () => ({type: TOGGLE_TIMESLIDER});

/**
 * @toggleTimeSlider
 */
export const toggleShowEventsBetweenTrips = () => ({type: TOGGLE_SHOW_EVENTS_BETWEEN_TRIPS});

/*
 * @toggleShowTripVisible
 */
export const toggleShowTripVisible = (state: boolean) => ({type: TOGGLE_SHOW_TRIP_VISIBLE, state});

/**
 * @toggleShowSummaryCards
 */
export const toggleShowSummaryCards = () => ({type: TOGGLE_SHOW_SUMMARY_CARDS});

export const toggleShowSummaryCard = (show) => ({type: TOGGLE_SHOW_SUMMARY_CARD, show});

// invokes when the user clicks distance card checkbox in AHR settings...
export const toggleDistanceTravelledCard = () => ({type: TOGGLE_DISTANCE_TRAVELLED_CARD});

// invokes when the user clicks idling card checkbox in AHR settings...
export const toggleIdlingTimeCard = () => ({type: TOGGLE_IDLING_TIME_CARD});

// invokes when the user clicks driving time card checkbox in AHR settings...
export const toggleDrivingTimeCard = () => ({type: TOGGLE_DRIVING_TIME_CARD});

// invokes when the user clicks harsh events card checkbox in AHR settings...
export const toggleHarshEventsCard = () => ({type: TOGGLE_HARSH_EVENTS_CARD});

// invokes when the user clicks total assets card checkbox in AHR settings...
export const toggleTotalAssetsCard = () => ({type: TOGGLE_TOTAL_ASSETS_CARD});
/**
 * @toggleErrorDialogue
 */
export const toggleErrorDialogue = (show: boolean, currentRequest = null) => ({
  type : SET_ASSETS_HISTORY_REPORT_ERROR,
  show,
  currentRequest
});

export const updateDateValue = (startDate, endDate, dateValue) => ({
  type : UPDATE_DATE_VALUE,
  startDate,
  endDate,
  dateValue
});

export const setIsMobileMapView = (isMobileMapView) => ({
  type : SET_IS_MOBILE_MAP_VIEW,
  isMobileMapView
});

export const setDvrAssets = (data) => ({
  type : SET_DVR_ASSETS,
  data
});

export const setSisenseDefaultDashboard = (id: null | DashboardId) => ({
  type : SET_SISENSE_DEFAULT_DASHBOARD,
  id
});
